import {Component, OnInit} from "@angular/core";

interface RolePermission {
  role: string;
  description: string;
  permission: string;
  actions: string[];
}

@Component({
  selector: "app-roles",
  templateUrl: "./roles.template.pug",
})
export class RolesComponent implements OnInit {
  rolePermissions: RolePermission[] = [];
  filteredRoles: RolePermission[] = [];
  paginatedRoles: RolePermission[] = [];
  pageNumbers: number[] = [];
  currentPage: number = 1;
  pageSize: number = 4;
  totalPages: number = 1;
  searchTerm: string = "";
  Math = Math;

  constructor() {}
  ngOnInit() {
    this.rolePermissions = [
      {
        role: "Credit Request Report Viewer",
        description: "Used to check credit History Report",
        permission: "Read",
        actions: [
          "View Credit Request History Report ",
        ],
      },
      {
        role: "Delivery Operations Administrator",
        description: "Used to enter the Contract administration details and ensures compliance with standard processes",
        permission: "Read & Write",
        actions: [
          "Import DART Deal",
          "Select/Assign Project Users",
          "Set up Contract Ops Information",
          "Create Master Agreement Contract",
          "Place Assets on Contract",
          "Deployed Assets Report",
        ],
      },
      {
        role: "Support",
        description: "Used to view the projects, sites and Master Agreement",
        permission: "Read",
        actions: [
          "View Projects",
          "View Sites",
          "View Master Agreement",
        ],
      },
      {
        role: "Transition Lead",
        description: "Used to create a project, set up the initial project set up and adding  additional Project Details",
        permission: "Read & Write",
        actions: [
          "View Projects",
          "Import Dart Deals",
          "Select/Assign Project Users",
          "Project Details ",
          "Setup Project Groups",
          "Site Details",
          "Individual Site Design",
          "Deployment Details",
          "Deploy Devices",
          "Pick Assets to Deploy",
        ],
      },
      {
        role: "Global Account Lead",
        description: "Used to create a project, set up the initial project set up  and adding additional Project Details and handle global deals",
        permission: "Read & Write",
        actions: [
          "View Projects",
          "Manage User Accounts",
          "Import Dart Deals",
          "Select/Assign Project Users",
          "Project Details ",
          "Setup Project Groups",
          "Site Details",
          "Individual Site Design",
          "Deployment Details",
          "Deploy Devices",
          "Pick Assets to Deploy",
        ],
      },
      {
        role: "Account Lead",
        description: "Used to create a project, set up the initial project set up  and adding additional Project Details and handle global deals",
        permission: "Read & Write",
        actions: [
          "View Projects",
          "Import dart deal",
          "Select/Assign Project Users",
          "Project Details",
          "Site details ",
          "Deployment Details",
          "Pick Assets to Deploy",
          "Deploy Devices",
        ],
      },
      {
        role: "Credit Analyst",
        description: "Used to check the Credit History report",
        permission: "Read",
        actions: [
          "View Credit Request History Report",
        ],
      },
      {
        role: "Delivery Admin Management",
        description: "Used to Review and place Hardware orders",
        permission: "Read & Write",
        actions: [
          "Import DART Deal",
          "Select/Assign Project Users",
          "Set up Contract Ops Information",
          "Create Master Agreement Contract",
          "Place Assets on Contract",
          "Deployed Assets Report",
          "Receive email notification of Credit check release",
        ],
      },
      {
        role: "Delivery Operations Product Support Specialist",
        description: "Used to enter the Contract administration details and ensures compliance with standard processes",
        permission: "Read & Write",
        actions: [
          "Setup Project Groups",
          "Can download deployed asset report",
        ],
      },
      {
        role: "Discovery and Design Lead",
        description: "Manage and inputs site design",
        permission: "Read & Write",
        actions: [
          "Import DART Deal",
          "Project Details",
        ],
      },
      {
        role: "Global Transition Lead",
        description: "Used to review and monitor global deals and performs transition lead activities",
        permission: "Read & Write",
        actions: [
          "View Projects",
          "Manage user accounts",
          "Import Dart Deals",
          "Select/Assign Project Users",
          "Project Details",
          "Setup Project Groups",
          "Site Details",
          "Individual Site Design",
          "Deployment Details",
          "Pick Assets to Deploy",
          "Deploy Devices",
        ],
      },
      {
        role: "Purge Master",
        description: "Handles project data cleanup for projects associated with Master Agreement",
        permission: "Read & Write",
        actions: [
          "Clear Project data",
        ],
      },
      {
        role: "Pursuit Lead",
        description: "Configure Solutions, Implement Plan & Support Win Strategy, Proposals, Deal Pre-sales activity",
        permission: "Read",
        actions: [
          "View import dart deal",
          "Project details",
        ],
      },
      {
        role: "Developer",
        description: "Used to review/analyse specific feature/behaviour for various development activity on need basis",
        permission: "Read",
        actions: [
          "View Projects",
          "View Sites",
          "View Master Agreement",
        ],
      },
      {
        role: "Manager",
        description: "View dashboards which provide device forecast & plan reports, used for reporting purpose only",
        permission: "Read & Write",
        actions: [
          "View Projects",
          "Manage user accounts",
          "Import Dart Deals",
          "Select/Assign Project Users",
          "Project Details",
          "Setup Project Groups",
          "Site Details",
          "Individual Site Design",
          "Deployment Details",
          "Pick Assets to Deploy",
          "Deploy Devices",
        ],
      },
      {
        role: "Manage Users",
        description: "View dashboards which provides device forecast & plan reports, used for reporting purpose ",
        permission: "Read",
        actions: [
          "View Dashboards",
        ],
      },
      {
        role: "Manage Service Accounts",
        description: "manage the accounts of the services which leverage TMC features like migration reconciliation, project/MA creation ",
        permission: "Read & Write",
        actions: [
          "Managing Service Accounts",
        ],
      },
      {
        role: "Super User",
        description: "Reviews and monitors global deals, manages the project and reviews contract administration details",
        permission: "Read & Write",
        actions: [
          "View Projects",
          "Manage user accounts",
          "Import Dart Deals",
          "Select/Assign Project Users",
          "Project Details",
          "Setup Project Groups",
          "Set up Contract Ops Information",
          "Create Master Agreement Contract",
          "Site Details",
          "Individual Site Design",
          "Deployment Details",
          "Pick Assets to Deploy",
          "Deploy Devices",
        ],
      },
    ];
    this.filteredRoles = [...this.rolePermissions];
    this.updatePagination();
    this.calculatePageNumbers();
  }

  search(): void {
    if (!this.searchTerm.trim()) {
      this.filteredRoles = [...this.rolePermissions];
    } else {
      const term = this.searchTerm.toLowerCase().trim();
      this.filteredRoles = this.rolePermissions.filter(role =>
        role.role.toLowerCase().includes(term) ||
        role.actions.some(action => action.toLowerCase().includes(term)));
    }
    this.currentPage = 1;
    this.updatePagination();
  }

  updatePagination(): void {
    this.totalPages = Math.ceil(this.filteredRoles.length / this.pageSize);
    if (this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages || 1;
    }
    this.paginate();
    this.calculatePageNumbers();
  }

  paginate(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = Math.min(startIndex + this.pageSize, this.filteredRoles.length);
    this.paginatedRoles = this.filteredRoles.slice(startIndex, endIndex);
  }

  setPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.paginate();
      this.calculatePageNumbers();
    }
  }

  calculatePageNumbers(): void {
    const pages: number[] = [];
    const safeTotal = Math.max(1, this.totalPages);
    for (let i = 1; i <= safeTotal; i++) {
      pages.push(i);
    }
    this.pageNumbers = pages;
  }
}
